import React from "react";
import { CategoryCardContainer } from "../style/components/CourseCard";
import { Link } from "react-router-dom";
import { getRandomColor } from "../utils/helper";

function CategoryCard({ category }) {
  const truncateText = (text, limit) => {
    if (text.length > limit) {
      return text.substring(0, limit) + "...";
    }
    return text;
  };
  return (
    <CategoryCardContainer>
      <Link  className="category-card" to={`/view-courses/${category.id}`} style={{ backgroundColor: getRandomColor(category.id) }}>
        <div className="title">{category.name}</div>
        <div className="description">{truncateText(category.description,30)}</div>
      </Link>
    </CategoryCardContainer>
  );
}

export default CategoryCard;
